import { TemplateRef } from "@angular/core"

export enum ColumnType {
  TEXT = 'text',
  NUMBER = 'number',
  DECIMAL = 'decimal',
  DATE = 'date',
  CHECKBOX = 'checkbox',
  ICON = 'icon',
  LINK = 'link',
  BUTTON = 'button',
  TEMPLATE = 'template',
  EXPAND = 'expand',
}

export type ICellColumnValue = string | number;

export interface IHeaderColumnValue<T> {
    key: keyof T | string,
    label: string,
    type: ColumnType,
    mobileHeader?: string,
    isSortable?: boolean,
    isCheckable?: boolean,
    width?: number;
}

export interface ILinkColumnValue {
    path: string;
    label: string;
}

export interface ICheckColumnValue {
    disabledRow?: boolean;
    checkedRow?: boolean;
}

export interface ITableColumn<T = any> {
    header: IHeaderColumnValue<T>;
    cellValue?: (data: T) => ICellColumnValue;
    linkValue?: (data: T) => ILinkColumnValue;
    checkValue?: (data: T) => ICheckColumnValue;
    template?: TemplateRef<any>;
}

export interface ITablePagination {
    total: number,
    pageSize: number,
    pageIndex: number
}
